import { styled, Typography } from '@material-ui/core';

const TextCell = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  letterSpacing: '0.005em',
  textAlign: 'left',
  color: '#232b3a',
});

export default TextCell;
